import { MessageBar, MessageBarType, PrimaryButton, Stack, TextField } from "@fluentui/react"
import { ProgressIndicator } from "@fluentui/react/lib/ProgressIndicator"
import { useEffect, useState } from "react"
import { useApiCall, useContact } from "../hooks/apiHooks"
import { getErrorText } from "../lib/helper"
import { IAccount, INewAccount } from "../types/IAccount"

function getNewCompanyBody(company: IAccount) {
	const body: Partial<INewAccount> = {
		name: company.name,
		address1_city: company.address1_city,
		address1_country: company.address1_country,
		address1_line1: company.address1_line1,
		address1_postalcode: company.address1_postalcode,
		telephone1: company.telephone1,
		address1_stateorprovince: company.address1_stateorprovince
	}

	return JSON.stringify(body)
}

const fields = [
	{ label: "Name", field: "name", required: true },
	{ label: "Address: Street 1", field: "address1_line1", required: true },
	{ label: "City", field: "address1_city", required: true }
]

interface MyAccountProps {
	controlType: "WebResource" | "Portal"
}

export function MyAccount({ controlType }: MyAccountProps) {
	const { contact, loading, error: contactError } = useContact()
	const [company, setCompany] = useState<IAccount | null>(null)
	const {
		loading: saving,
		fetchData: saveItem,
		error: savingError
	} = useApiCall<any>(`accounts(${company?.accountid})`, { crm: true, handlerOnly: true, method: "PATCH", body: getNewCompanyBody(company), errorParser: getErrorText })
	const error = contactError || savingError

	useEffect(() => {
		if (!contact) return
		setCompany(contact.parentcustomerid_account)
	}, [contact])

	const handleChange = (field: string, value: string) => setCompany(prev => ({ ...prev, [field]: value }))
	const saveButtonDisabled = !company.address1_city || !company.address1_stateorprovince || !company.address1_postalcode || !company.name || saving

	return (
		<Stack tokens={{ childrenGap: 10 }} style={{ padding: 15 }}>
			{error && <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>}
			{loading && <ProgressIndicator />}
			{company && (
				<Stack tokens={{ childrenGap: 10 }}>
					{fields.map(({ field, label, required }) => (
						<TextField key={field} label={label} value={company[field]} required={required} onChange={(_ev, value) => handleChange(field, value || "")} />
					))}
					<Stack tokens={{ childrenGap: 10 }}>
						{error && <MessageBar messageBarType={MessageBarType.error}>{error}</MessageBar>}
						{saving && <ProgressIndicator label="This may take a minute" />}
						<Stack horizontal tokens={{ childrenGap: 10 }}>
							<PrimaryButton onClick={saveItem} disabled={saveButtonDisabled}>
								Save
							</PrimaryButton>
						</Stack>
					</Stack>
				</Stack>
			)}
		</Stack>
	)
}
